import React, { useState, useEffect } from "react";
import "./style.css";
import { Col, Row } from "antd";
import NavbarComponent from "../NavbarComponent";
import Footer from "../FooterComponent";

import { useDispatch } from "react-redux";
import { updateProductsState } from "../../store/profile";
import { useSelector } from "react-redux";

import { checkCartIfExist } from "../../helper";
import { LoadingOutlined } from "@ant-design/icons";

function Transporate() {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.profile);

  const [loading, setloading] = useState(false);
  const [hitUseEffect, sethitUseEffect] = useState(false);

  const handleLoading = () => {
    setloading(false);
  };

  useEffect(() => {
    setloading(true);

    setTimeout(handleLoading, 1000);
  }, [hitUseEffect, products]);
  return (
    <>
      <NavbarComponent />
      <div className="transporteBlock">
        <h2 className="headingclassofoilrig">TRANSPORTANDO TU MAQUINARIA CON PRECISION Y EFICIENCIA</h2>
      </div>
      <div>
        <Row justify="center" className="hills">
          <Col lg={16} md={24} xs={24}>
            <div className="" style={{margin: "2rem"}}>
              <h5 className="headertun">
                TRANSPORTE DE MAQUINARIA PESADA
              </h5>
              <p
                style={{
                  textAlign: "justify",
                }}
                className=""
              >
                En JL LOGISTICA, estamos en una misión constante de excelencia
                en el trasporte de maquinaria. Nuestro compromiso se basa en la
                dedicación total a la satisfacción del cliente y en la promesa
                de entregar su maquinaria en las mejores condiciones. Nuestra
                mentalidad de mejora continua nos impulsa hacia adelante.
              </p>
            </div>
            <div className="coti-hol">
              {loading ? (
                <LoadingOutlined />
              ) : (
                <>
                  {checkCartIfExist("TRANSPORTE DE MAQUINARIA PESADA") ? (
                    <p style={{ color: "green" }}>Added!</p>
                  ) : (
                    <button
                      className="bton-coti"
                      onClick={() => {
                        dispatch(
                          updateProductsState({
                            class:
                              "TRANSPORTANDO TU MAQUINARIA CONPRECISION Y EFICIENCIA",
                            name: "TRANSPORTE DE MAQUINARIA PESADA",
                          })
                        );

                        setloading(true);
                        sethitUseEffect(!hitUseEffect);
                      }}
                    >
                      <h6 className="teni">COTIZAR</h6>
                    </button>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <Footer />
    </>
  );
}

export default Transporate;
